"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SKELETON_WIDTHS = void 0;
exports.Skeleton = Skeleton;
exports.skeletonWidth = skeletonWidth;
const jsx_runtime_1 = require("react/jsx-runtime");
const cn_1 = require("../lib/cn");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ One placeholder bar — what a list cell looks like before its data lands.   │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * `state-rules.md` §1 as amended 13 Oct 2026: a list draws skeleton rows on its first load, never
 * its empty state. Every surface that does — `DataList`, `DataGrid`, the settings tables — draws
 * this bar, so they pulse alike.
 *
 * ⚠️ **`animate-pulse` and nothing else.** The design system's motion rule allows exactly that
 * much; no shimmer, no sweep.
 *
 * ⚠️ **`aria-hidden`.** A bar says nothing; the surface's one `role="status"` line speaks for all
 * of them.
 */
function Skeleton({ width, className, }) {
    const style = width === undefined
        ? undefined
        : { width: typeof width === 'number' ? `${String(width)}%` : width };
    return ((0, jsx_runtime_1.jsx)("div", { "aria-hidden": true, className: (0, cn_1.cn)('bg-muted h-3 animate-pulse rounded-[4px]', className), style: style }));
}
/**
 * The bar widths a skeleton row cycles through, as percentages of each cell. Eight rows, varied so
 * the placeholder reads as a list of different things rather than as a striped background.
 */
exports.SKELETON_WIDTHS = [
    [62, 78, 45, 70, 55, 40],
    [48, 64, 70, 52, 66, 58],
    [70, 50, 58, 44, 72, 46],
    [56, 72, 40, 66, 48, 62],
    [66, 46, 62, 58, 54, 70],
    [44, 68, 54, 74, 60, 50],
    [60, 56, 66, 48, 70, 44],
    [52, 74, 48, 62, 46, 66],
];
/** The width for column `column` of skeleton row `row`. */
function skeletonWidth(row, column) {
    const widths = exports.SKELETON_WIDTHS[row % exports.SKELETON_WIDTHS.length] ?? [];
    return widths[column % Math.max(1, widths.length)] ?? 60;
}
//# sourceMappingURL=skeleton.js.map